import { render, staticRenderFns } from "./NonMovingItemsReport.vue?vue&type=template&id=60800625"
import script from "./NonMovingItemsReport.vue?vue&type=script&lang=js"
export * from "./NonMovingItemsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports